// extracted by mini-css-extract-plugin
export default {"label":"MatchingText__label___VHYaM","matchedPart":"MatchingText__matchedPart___QDxw8","firstNonMatchingPart":"MatchingText__firstNonMatchingPart___qhfeB"};